
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#222","d":"M19.302 22h-14.6a2.664 2.664 0 01-2.4-1.1 2.661 2.661 0 01.1-2.629l7.409-14.81A2.66 2.66 0 0112.002 2a2.665 2.665 0 012.191 1.461l7.409 14.81a2.664 2.664 0 01.09 2.632A2.662 2.662 0 0119.302 22zm-7.3-4.94a1.354 1.354 0 101.354 1.354 1.356 1.356 0 00-1.354-1.354zm0-10.213A1.356 1.356 0 0010.645 8.2v6.13a1.354 1.354 0 102.708 0V8.2a1.356 1.356 0 00-1.351-1.353z"}})])
          )
        }
      }
    